<template>
  <div class='w-full h-dvh p-4 bg-jananavy-900 flex'>
    <div class='m-auto'>
      <div class='p-6 sm:p-8 bg-white rounded-md shadow-sm max-w-[30rem]'>
        <div class='flex justify-center items-center gap-4'>
          <img class='h-6 md:h-8' src='@/assets/artwork/jana-logo-blue.svg' alt='Steward' />
          <img class='h-6 md:h-8' src='@/assets/artwork/platform-logo-blue.svg' alt='Steward' />
        </div>
        <h1 class='mt-6 text-3xl text-center'>404</h1>
        <p class='mt-2 text-center'>The page you requested could not be found.</p>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>
